module.exports = {
  header: {
    display: 'flex',
    alignItems: 'center',
  },
  helpButtonContainer: {
    width: '88px',
  },
  icon: {
    height: '35px',
    width: '35px',
    marginRight: '10px',
    position: 'relative',
    top: '6px',
  },
  link: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    marginBottom: '3px',
  },
  selectField: {
    top: '-12px',
    marginLeft: '16px',
  },
  tag: {
    background: '#e6f3ff',
    padding: '0 3px',
    display: 'inline-block',
    color: '#575f67',
    fontWeight: 400,
    marginBottom: '2px',
  },
  tagList: {
    listStyle: 'none',
    paddingLeft: '0',
    width: '176px',
    margin: '10px auto',
    textAlign: 'left',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
}



// WEBPACK FOOTER //
// ./src/components/Settings/PostApptReviewMessageEditor/link-styles.js